const luxMobile = {
  fa: {
    header: {
      title: "لوکس موبایل",
      intro:
        "لوکس موبایل یک رابط فروشگاهی مدرن برای معرفی و فروش گوشی‌های هوشمند است که با تمرکز بر ایجاد حس لوکس، نمایش برجسته محصولات و ارائه یک تجربه کاربری روان طراحی و توسعه داده شده است.",
      description: [
        "در طراحی صفحه، بخش‌های مختلف فروشگاه از جمله نوار ناوبری، جست‌وجو، بخش معرفی اصلی، مزیت‌های فروشگاه، پیشنهادهای ویژه و کارت‌های محصول در کنار یکدیگر قرار گرفته‌اند تا کاربر بتواند در یک نگاه محصولات، قیمت‌ها، تخفیف‌ها و اطلاعات اصلی را مشاهده و بررسی کند.",

        "این پروژه با ری‌اکت توسعه داده شده و ساختار آن بر پایه اجزای مستقل شکل گرفته است. یکی از چالش‌های اصلی، ایجاد تعادل میان تصاویر بزرگ، محتوای متنی و المان‌های فروشگاهی بود؛ به‌خصوص در بخش محصولات که اطلاعاتی مانند نام، ظرفیت، قیمت اصلی، قیمت تخفیف‌خورده و درصد تخفیف باید بدون شلوغ شدن رابط کاربری نمایش داده شوند.",

        "در کنار ظاهر بصری، طراحی واکنش‌گرا، ساختار راست‌به‌چپ و حفظ نظم بصری در اندازه‌های مختلف نمایشگر نیز مورد توجه قرار گرفته تا رابط فروشگاه در دستگاه‌های مختلف یکپارچه و قابل استفاده باقی بماند.",
      ],
      image: "imgs/ProjectRecords/LuxMobile/mark2.jpg",
    },
    side: {
      Project: "LuxMobile",
      LiveDemo: "",
      Language: "فارسی",
      Date: "مرداد ۱۴۰۵",
      Technologies:
        "React · Responsive Design · E-commerce UI · RTL Support · Product Cards · Pricing & Discounts · Special Offers",
    },
  },

  en: {
    header: {
      title: "Lux Mobile",
      intro:
        "Lux Mobile is a modern e-commerce interface designed for showcasing and selling smartphones, with a focus on creating a premium visual identity, highlighting products, and providing a smooth shopping experience.",
      description: [
        "The interface brings together key storefront sections including navigation, search, a hero section, store benefits, special offers, and product cards. The goal was to create a clear visual hierarchy that allows users to quickly explore products and understand essential information such as pricing, discounts, storage options, and product names.",

        "Built with React, the project follows a component-based structure with independent sections for different parts of the storefront. One of the main challenges was balancing large visual elements with detailed product information, while keeping the interface clean and easy to scan.",

        "The project also focuses on responsive design, RTL support, and consistent visual structure across different screen sizes, ensuring that the storefront remains organized and usable across devices.",
      ],
      image: "imgs/ProjectRecords/LuxMobile/mark2.jpg",
    },
    side: {
      Project: "Lux Mobile",
      LiveDemo: "",
      Language: "Persian",
      Date: "August 2026",
      Technologies:
        "React · Responsive Design · E-commerce UI · RTL Support · Product Cards · Pricing & Discounts · Special Offers",
    },
  },
};

export default luxMobile;
